import React from 'react';
import SignInOrSignUpPage from './shared/SignInOrSignUpPage';

const LoginPage = props => <SignInOrSignUpPage type="login" {...props} />;
export default LoginPage;
